module.exports = __webpack_public_path__ + "static/media/at-home-med.4edef93f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/at-home-med.png
// module id = 43
// module chunks = 0